// =====================================================================
// lib/pagesPubliques.js — pages ouvertes SANS compte Zeus (16-10-2026)
// =====================================================================
// Une seule liste pour l'intercepteur 401 (services/api.js : pas de renvoi vers
// /login) et l'affichage plein écran (App.jsx : pas de barre Zeus) :
//   /embauche/<token>  M-011, candidat (QR)
//   /order/<token>     Commande prête, photos d'une commande (lien du mail)
//   /client/<token>    Commandes prêtes v2, page du client (lien sécurisé par client)
//   /mot-de-passe-oublie, /mot-de-passe (23-10-2026) : demander un lien, puis choisir un mot de passe (jeton dans le #)
// Une nouvelle page publique s'ajoute ICI (+ sa <Route> dans App.jsx, avec et sans compte).
// =====================================================================

export const PREFIXES_PUBLICS = Object.freeze(['/embauche/', '/order/', '/client/']);
export const CHEMINS_PUBLICS = Object.freeze(['/mot-de-passe-oublie', '/mot-de-passe']);

export const estPagePublique = (chemin) => CHEMINS_PUBLICS.includes(String(chemin || ''))
  || PREFIXES_PUBLICS.some((p) => String(chemin || '').startsWith(p));
